import { useEffect } from "react"
import { useAuthUser, useIsAuthenticated } from "react-auth-kit"
import { useNavigate } from "react-router-dom"

export const useAdminAuth = () => {
  const navigate = useNavigate()
  const isAuthenticated = useIsAuthenticated()
  const authUser = useAuthUser()

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate("/admin/login")
      return
    }

    if (!["eventAdmin", "appAdmin"].includes(authUser()?.type)) {
      navigate("/not-authorized?message=You%20are%20not%20an%20admin")
    }
  }, [authUser, isAuthenticated, navigate])

  return authUser
}
